import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCategoryName, getCategorySlug, getFromPath } from 'src/helpers/utils';
import { setSelectedCategory } from 'src/store/app/actions';
import { RootState } from 'src/types/store-types';
import { CASINO_CATEGORIES } from '../utils/constants';
import { useConnectedAction } from './use-connected-action';

type NavigateToCategory = () => void;

export const useNavigateToCategory = (): NavigateToCategory => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const _setSelectedCategory = useConnectedAction(setSelectedCategory);
  const { navigation } = useSelector((state: RootState) => state.configs);

  return useCallback(() => {
    if (pathname.includes('category')) {
      // URL segment is the slug; selectedCategory must be the name (the data key)
      _setSelectedCategory(getCategoryName(navigation, getFromPath(pathname, '/', 2)));
      return;
    }

    const defaultCategory = process.env.REACT_APP_DEFAULT_CATEGORY;
    if (CASINO_CATEGORIES.includes(defaultCategory as string)) {
      // the env holds the category name; the route is registered by slug
      navigate(`/category/${getCategorySlug(navigation, defaultCategory as string)}`);
    }

    _setSelectedCategory(defaultCategory);
  }, [navigate, pathname, _setSelectedCategory, navigation]);
};
